import { render, staticRenderFns } from "./CsoProcurementCost.vue?vue&type=template&id=52a6f6f6&scoped=true"
import script from "./CsoProcurementCost.vue?vue&type=script&lang=js"
export * from "./CsoProcurementCost.vue?vue&type=script&lang=js"
import style0 from "./CsoProcurementCost.vue?vue&type=style&index=0&id=52a6f6f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a6f6f6",
  null
  
)

export default component.exports